import {
	CheckinOrderFragment,
	CheckinSaveOrderServicesMutation,
	CheckinSegmentFragment,
	CheckoutOrderFragment,
	FlightFragment,
	GetCheckinOrderQuery,
	OrderQuery,
	SaveOrderServicesMutation
} from '@websky/graphql';
import { DefaultRootState } from 'react-redux';
import { ResultsState } from './Results/store/reducers';
import { CheckoutState } from './Checkout/store/reducers';

// States
export const isCheckoutOrderGuard = (
	order: CheckoutOrderFragment | CheckinOrderFragment
): order is CheckoutOrderFragment => {
	return order.hasOwnProperty('locator');
};

export const isResultsStateGuard = (state: DefaultRootState | ResultsState | CheckoutState): state is ResultsState => {
	return 'legs' in state;
};

export const isCheckoutStateGuard = (
	state: DefaultRootState | ResultsState | CheckoutState
): state is CheckoutState => {
	return 'passengers' in state;
};

// Responses
export const isOrderServicesResponse = (
	response: CheckinSaveOrderServicesMutation | SaveOrderServicesMutation
): response is SaveOrderServicesMutation => {
	return (response as SaveOrderServicesMutation)?.SaveOrderServices !== undefined;
};

export const isCheckinOrderServicesResponse = (
	response: CheckinSaveOrderServicesMutation | SaveOrderServicesMutation
): response is CheckinSaveOrderServicesMutation => {
	return (response as CheckinSaveOrderServicesMutation)?.CheckinSaveOrderServices !== undefined;
};

export const isOrderResponse = (response: OrderQuery | GetCheckinOrderQuery): response is OrderQuery => {
	return (response as OrderQuery)?.Order !== undefined;
};

export const isCheckinOrderResponse = (
	response: OrderQuery | GetCheckinOrderQuery
): response is GetCheckinOrderQuery => {
	return (response as GetCheckinOrderQuery)?.CheckinOrder !== undefined;
};

export const isCheckinFlightGuard = (
	flight: CheckinSegmentFragment | FlightFragment
): flight is CheckinSegmentFragment => {
	return (flight as CheckinSegmentFragment)?.checkinInfo !== undefined;
};
